import React from 'react'
import { useGetMe, useGetWallet } from '@/domain'
import { useUserAuthSessionStore } from '@/store'
import { BaseView, BaseText } from '@/components/base'
import { AppButton } from '@/components'

export const DebugApiScreen: React.FC = () => {
  const { token, isSessionOpen } = useUserAuthSessionStore()
  const {
    data: userData,
    isLoading: userLoading,
    error: userError,
  } = useGetMe()
  const {
    data: walletData,
    isLoading: walletLoading,
    error: walletError,
  } = useGetWallet()

  return (
    <BaseView p={20} gap={20} bgColor="background.screen" className="h-full">
      <BaseText fontSize={24} fontFamily="bold" color="label.default">
        API Debug Screen
      </BaseText>

      {/* Auth Status */}
      <BaseView gap={8}>
        <BaseText fontSize={18} fontFamily="semibold" color="label.primary">
          Auth Status:
        </BaseText>
        <BaseText fontSize={14} color="label.default">
          Token: {token ? `${token.substring(0, 20)}...` : 'No token'}
        </BaseText>
        <BaseText fontSize={14} color="label.default">
          Session Open: {isSessionOpen ? 'Yes' : 'No'}
        </BaseText>
      </BaseView>

      {/* User API */}
      <BaseView gap={8}>
        <BaseText fontSize={18} fontFamily="semibold" color="label.primary">
          User API (/v1/identity/me):
        </BaseText>
        <BaseText fontSize={14} color="label.default">
          Loading: {userLoading ? 'Yes' : 'No'}
        </BaseText>
        <BaseText fontSize={14} color="label.default">
          Error: {userError ? JSON.stringify(userError, null, 2) : 'None'}
        </BaseText>
        <BaseText fontSize={14} color="label.default">
          Data: {userData ? JSON.stringify(userData, null, 2) : 'None'}
        </BaseText>
      </BaseView>

      {/* Wallet API */}
      <BaseView gap={8}>
        <BaseText fontSize={18} fontFamily="semibold" color="label.primary">
          Wallet API (/v1/wallet/get_wallet):
        </BaseText>
        <BaseText fontSize={14} color="label.default">
          Loading: {walletLoading ? 'Yes' : 'No'}
        </BaseText>
        <BaseText fontSize={14} color="label.default">
          Error: {walletError ? JSON.stringify(walletError, null, 2) : 'None'}
        </BaseText>
        <BaseText fontSize={14} color="label.default">
          Data: {walletData ? JSON.stringify(walletData, null, 2) : 'None'}
        </BaseText>
      </BaseView>

      <AppButton
        label="Go to Dashboard"
        onClick={() => (window.location.href = '/dashboard')}
      />
    </BaseView>
  )
}
